export const forms = {
    addInfoForm: 'addInfoForm',
    updateInfoForm: 'updateInfoForm',
    addInfoCategoryForm: 'addInfoCategoryForm',
    updateInfoCategoryForm: 'updateInfoCategoryForm',
};

export const infoCategoryFields = {
    name: 'name',
};
export const infoFields = {
    title: 'title',
    body: 'body',
};

export const localizableInfoCategoryFields = [infoCategoryFields.name];
export const requiredInfoCategoryFields = [infoCategoryFields.name];

export const localizableInfoFields = [infoFields.title, infoFields.body];
export const requiredInfoFields = [infoFields.title];

export const defaultInfoValues = {};
export const defaultInfoCategoryValues = {};
